<template>
  <p class="no-data">{{ text || $t('common.noData') }}</p>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.no-data{
  width: 100%;
  color: #666;
  font-size: 14px;
  text-align: center;
  line-height: 100px;
}
</style>
